import { Injectable } from '@angular/core';
import { BuilderPreviewScriptApiParameters } from './Parameters/BuilderPreviewScriptApiParameters';
import { HttpUtils } from '../../../shared/http/HttpUtils';

@Injectable({
    providedIn: 'root'
})

export class BuilderPreviewScriptApi
{
    private apiUrl = '/api/preview/script';

    public async Get(buttonForeGroundColor: string, buttonBackgroundColor: string, buttonIcon: string): Promise<string>
    {
        const parameters: BuilderPreviewScriptApiParameters = {
            ButtonForeGroundColor: buttonForeGroundColor,
            ButtonBackgroundColor: buttonBackgroundColor,
            ButtonIcon: buttonIcon
        };

        const response = await fetch(`${this.apiUrl}?${new URLSearchParams(parameters as any).toString()}`);

        await HttpUtils.ProcessFetchResultAsync(response);

        return await response.text();
    }
}
